import '@pieleaf/monitoring/browser';
import { type AuthState, bootSession, delegateAuthControls } from '@bomdisoft/auth-bff/native';
import { defineLanguageOffer, registerServiceWorker, whenActivated } from '@bomdisoft/components/native';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { BOMDISOFT_LINKED_DOMAINS } from '@bomdisoft/utilities';
import { STOREFRONT_SELECTOR } from '@pieleaf/frame/storefront-selector';
import { PIELEAF_ROUTES } from '@pieleaf/lib/webmcp/routes';
import { toTopBarAuthOptions } from '@pieleaf/shared/top-bar/render';

whenActivated(document, () => {
  const lang = document.documentElement.lang || 'en';

  void import('@pieleaf/frame/analytics').then(({ startAnalytics }) => startAnalytics({ apiKey: process.env.NEXT_PUBLIC_PRODANTIX_KEY ?? '', host: process.env.NEXT_PUBLIC_PRODANTIX_HOST ?? '', linkedDomains: BOMDISOFT_LINKED_DOMAINS, messengerHost: process.env.NEXT_PUBLIC_PRODANTIX_EDGE_HOST }));

  registerServiceWorker(window, { isProduction: process.env.NODE_ENV === 'production', language: getLanguageFromLocale(lang) });

  let resolveSession: (state: AuthState) => void = () => {};
  const session = new Promise<AuthState>(resolve => {
    resolveSession = resolve;
  });
  const authSlot = document.querySelector<HTMLElement>('.bomdisoft-top-bar-right-group');
  if (authSlot === null) resolveSession({ status: 'unauthenticated' });
  else
    delegateAuthControls(authSlot, toTopBarAuthOptions(lang), {
      boot: async options => {
        const state = await bootSession(options);
        resolveSession(state);
        return state;
      },
      oidc: true,
    });

  if (document.querySelector(STOREFRONT_SELECTOR) !== null) void import('@pieleaf/frame/storefront').then(({ mountStorefront }) => mountStorefront(document, { lang, session }));

  defineLanguageOffer(window);

  const mountAgentSurface = async () => {
    const { mountWebMcp, toLocationRouter } = await import('@bomdisoft/webmcp-ui/native');
    const root = document.createElement('div');
    document.body.append(root);
    mountWebMcp(root, { i18n: { locale: lang }, language: getLanguageFromLocale(lang), router: toLocationRouter(window), routes: PIELEAF_ROUTES });
  };

  if (typeof requestIdleCallback === 'function') requestIdleCallback(() => void mountAgentSurface());
  else setTimeout(() => void mountAgentSurface(), 2000);
});
